import styled from 'styled-components';

export default styled.div`
  position: absolute;
  top: 16px;
  right: 24px;
`;
